<template>
  <div id="assessmentproxy" class="module_assessment page_content" aria-label="Create Assessment Page Content">
    <div>
      <div class="row page-heading border-0" role="heading" aria-level="1">
        <div class="col-9 input module_heading" :class="{invalid: $v.model.title.$error}">
          <span class="icon-assessment float-left"></span>
          <input
            type="text"
            id="title"
            class="module_title ace_sec_txt"
            @blur="$v.model.title.$touch()"
            placeholder="Type assessment name*"
            aria-label="type assessment name"
            v-model.trim="model.title" v-focus>
        </div>
        <div class="col-3 submit btn-container text-right">
          <!--<span class="float-right"><span class="fas fa-th"></span></span>-->
          <button class="btn-cancel" @click.stop="cancel"><span class="icon-cross" aria-label="close"></span></button>
          <button class="btn btn-primary" @click.stop="onSubmit(true)" :disabled="(model.addedItemList.length === 0)" aria-label="done">done</button>
          <button class="btn btn-primary" @click.stop="onSubmit(false)" :disabled="(model.addedItemList.length === 0)" aria-label="save">save</button>
        </div>
      </div>
      <div class="page-content">
        <div class="row assessment-section">
          <div class="col-8 assessment-left-section">
            <div class="page-section">
              <div class="page_section_row">
                <div class="heading border-0">
                  <span for="description" id="AssessmentDescription">Assessment Description</span>
                </div>
                <div class="value ml-3">
                  <textarea rows="4" cols="50"
                    id="description"
                    placeholder="Type in the assessment description..."
                    aria-labelledby="AssessmentDescription"
                    v-model="model.description">
                  </textarea>
                </div>
              </div>
              <div class="page_section_row row create mt-2">
                <div class="max-attempts col-6">
                  <div class="heading border-0 pt-1">
                    <label for="maxAttempt" id="maximumAttempt">Maximum # of Attempts</label>
                  </div>
                  <div class="max-attempt-value" :class="{invalid: $v.model.maxAttempt.$error}">
                    <input
                      type="number"
                      id="maxAttempt"
                      @blur="$v.model.maxAttempt.$touch()"
                      aria-labelledby="maximumAttempt"
                      v-model.number="model.maxAttempt">
                  </div>
                </div>
                <div class="max-attempts col-6">
                  <div class="heading border-0 pt-1">
                    <label for="folder" id="folderName">Folder</label>
                  </div>
                  <div class="folder-name">
                    <select id="folder" v-model="model.owningLibraryId" aria-labelledby="folderName">
                      <option v-for="folder in folders" :value="folder.uuid">{{ folder.displayName }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="page_section_row row create">
                <div class="error max-attempts col-6 ml-2" v-if="!$v.model.maxAttempt.required">Maximum # of Attempts is required.</div>
                <div class="error max-attempts col-6 ml-2" v-if="!$v.model.maxAttempt.minVal">Maximum # of Attempts must be greater than or equal to 1.</div>
              </div>
              <div class="page_section_row row create">
                <div class="max-attempts col-12">
                  <div class="heading border-0">
                    <label for="manualGradingRubricPdfUri">Manual Grading Instruction Document URL</label>
                  </div>
                  <div class="value url pl-0" :class="{invalid: $v.model.manualGradingRubricPdfUri.$error}" style="width: calc(100% - 40px);">
                    <input
                      type="text"
                      id="manualGradingRubricPdfUri"
                      placeholder="http://"
                      v-model.trim="model.manualGradingRubricPdfUri"
                      style="padding-left:8px;">
                  </div>
                </div>
              </div>
              <div class="page_section_row row create">
                <div class="error max-attempts col-6 ml-2" v-if="!$v.model.manualGradingRubricPdfUri.url">Invalid document URL.</div>
              </div>
            </div>
          </div>
          <div class="page_section_row assessment-right-section col-4">
            <div class="heading">
              <span class="ic-tag general mr-2"></span>
              <span id="assessmentTags">Assessment Tags</span>
              <b-btn class="btn_ic ml-2" @click="showAddTagPopup($event)">
                <span class="icon-pencil2"></span>
              </b-btn>
            </div>
            <div class="value tags_container">
              <div class="tag-box-list" style="height: 95px !important;">
                <template v-for="(values, key, i) in model.appliedTagMap" class="tags_container">
                  <span class="tag" v-for="(tag, j) in values">
                  <span class="tag_name instructional_tag ace_sec_txt">{{tag.name}}</span>
                  </span>
                </template>
              </div>
            </div>
            <div class="mt-4">
              <div class="row checkbox_row">
                <div class="col-12 checkbox_fld">
                  <input type="checkbox" id="checkbox" aria-labelledby="practiceTest" v-model="model.localPractice">
                  <label id="practiceTest">Practice Test</label>
                </div>
                <div class="col-12 checkbox_fld">
                  <input type="checkbox" id="checkbox" aria-labelledby="Pre Diagnostic Test" v-model="model.diagonesticTest">
                  <label id="diagonesticTest">Pre Diagnostic Test <!--with PPC--> </label>
                </div>
                <div class="col-12 checkbox_fld">
                  <input type="checkbox" id="checkbox" aria-labelledby="Post Diagnostic Test" v-model="model.diagonesticReportTest">
                  <label id="diagonesticReportTest">Post Diagnostic Test</label>
                </div>
              </div>
            </div>
            <template>
              <add-tag-popup v-if="isShowTagPopup" :entity-data="taggingEntityData"></add-tag-popup>
            </template>
          </div>
        </div>
        <div class="mt-3">
          <div id="learnosity-author"></div>
        </div>
      </div>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>
    <div>
      <data-loss-prompt ref="dataLossAlert" @okLose="okLose" @saveAndContinue="saveAndContinue"></data-loss-prompt>
    </div>
  </div>
</template>

<script>
  /* global LearnosityAuthor:true */
  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import Vuelidate from 'vuelidate'
  import _ from 'lodash'
  import AddTagPopup from '../../tagging/components/AddTagPopup'
  import '../../../assets/module/less/create_entity.less'
  import DataLossPrompt from '../../common/components/DataLossPrompt'
  import {required, minLength, numeric, minValue, url} from 'vuelidate/lib/validators'
  Vue.use(Vuelidate)
  Vue.directive('focus', {
    inserted (el) {
      el.focus()
    }
  })

  export default {
    name: 'createAssessment',
    components: {
      AddTagPopup,
      DataLossPrompt
    },
    data () {
      return {
        authorApp: {},
        model: {
          title: '',
          description: '',
          maxAttempt: 1,
          owningLibraryId: undefined,
          addedItemList: [],
          localPractice: false,
          diagonesticTest: false,
          diagonesticReportTest: false,
          appliedTagMap: {},
          manualGradingRubricPdfUri: ''
        },
        assessment: '',
        folders: [],
        selectedItemList: [],
        isShowTagPopup: false,
        taggingEntityData: {},
        nextPage: undefined,
        dirty: false,
        oldModel: {}
      }
    },
    validations: {
      model: {
        title: {
          required,
          minLength: minLength(1)
        },
        maxAttempt: {
          required,
          numeric,
          minVal: minValue(1)
        },
        manualGradingRubricPdfUri: {
          url
        }
      }
    },

    mounted () {
      const userId = localStorage.getItem('userid')
      this.loadLibrariesForUser(userId).then(learningSpaces => {
        this.folders = []
        for (var i = 0; i < learningSpaces.length; i++) {
          const learningSpace = learningSpaces[i]
          const permission = learningSpace.acelist[0].permission
          if (permission && permission.folderPermission && permission.folderPermission.allowedAsDestinationFolder) {
            this.folders.push(learningSpace)
            if (learningSpace.category === 'Institute_Public') {
              this.model.owningLibraryId = learningSpace.uuid
            }
          }
        }
        if (this.folders.length > 0) {
          if (!this.model.owningLibraryId) {
            this.model.owningLibraryId = this.folders[0].uuid
          }
          this.createAssessment().then(res => {
            if (res) {
              this.assessment = res.assessment
              const signedRequest = JSON.parse(res.signedRequest)
              var eventOptions = {
                readyListener: this.init
              }
              this.authorApp = LearnosityAuthor.init(signedRequest, eventOptions)
            }
          })
          this.$data.oldModel = _.cloneDeep(this.$data.model)
        }
      })
    },

    beforeRouteLeave (to, from, next) {
      if (this.dirty) {
        this.nextPage = next
        this.$refs.dataLossAlert.showPrompt()
        next(false)
      } else {
        next()
      }
    },

    methods: {
      ...mapActions([
        'createAssessment',
        'loadLibrariesForUser',
        'saveActivityAtLearnosity'
      ]),

      init() {
        // 1. Handle native item selection changes cleanly via the API
        this.authorApp.on('itemlist:selection:changed', (event) => {
          this.selectedItemList = event.data.itemRefs
        });

        // 2. Use the native lifecycle event instead of direct jQuery click bindings
        this.authorApp.on('activityedit:items:added', (event) => {
          this.model.addedItemList =  this.selectedItemList
          this.selectedItemList = []
        });

        this.authorApp.on('render:activity', (event) => {
          this.authorApp.navigate(`activities/${this.assessment.uuid}/searchItems`)
        })
      },

      showAddTagPopup (event) {
        this.isShowTagPopup = true
        this.taggingEntityData = {title: this.model.title, type: 'assets', appliedTagMap: this.model.appliedTagMap}
        setTimeout(() => {
          this.$root.$emit('bv::show::modal', 'addTagPopup', event.target)
        }, 500)
      },

      cancel () {
        this.$router.go(-1)
      },

      onSubmit (isDone) {
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }
        this.dirty = false
        this.$refs.loadingModal.show()
        this.authorApp.saveActivity()
        const formData = {
          uuid: this.assessment.uuid,
          title: this.model.title,
          description: this.model.description,
          maxAttempt: this.model.maxAttempt,
          appliedTagMap: this.model.appliedTagMap,
          ancestor: this.model.owningLibraryId,
          owningLibraryId: this.model.owningLibraryId,
          localPractice: this.model.localPractice,
          diagonesticTest: this.model.diagonesticTest,
          diagonesticReportTest: this.model.diagonesticReportTest,
          manualGradingRubricPdfUri: this.model.manualGradingRubricPdfUri
        }
        this.saveActivityAtLearnosity(formData).then(res => {
          this.$data.oldModel = _.cloneDeep(this.$data.model)
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Assessment "' + this.model.title + '" created and saved successfully.'
          })
          this.$refs.loadingModal.hide()
          if (isDone) {
            if (this.nextPage) {
              this.$emit('resolveNext', this.nextPage)
            } else {
              return this.$router.push({ name: 'assessmentDetail', params: { uuid: this.assessment.uuid, isCreated: true } })
            }
          } else {
            return this.$router.push({ name: 'editAssessment', params: { uuid: this.assessment.uuid } })
          }
        })
      },

      okLose () {
        this.$emit('resolveNext', this.nextPage)
      },

      saveAndContinue () {
        this.onSubmit(true)
      }
    },

    watch: {
      model: {
        handler () {
          this.dirty = !_.isEqual(this.$data.model, this.$data.oldModel)
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  .proxy-form {
    width: 400px;
    margin: 30px auto;
    border: 1px solid #eee;
    padding: 20px;
    box-shadow: 0 2px 3px #ccc;
  }

  .input {
    margin: 10px auto;
  }

  .input label {
    display: block;
    color: #4e4e4e;
    margin-bottom: 6px;
  }

  .input.inline label {
    display: inline;
  }

  .input input {
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }

  .input.inline input {
    width: auto;
  }

  .input input:focus {
    outline: none;
    border: 1px solid #521751;
    background-color: #eee;
  }

  .input.invalid label, .error {
    color: red;
  }

  .invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
  }

  .input select {
    border: 1px solid #ccc;
    font: inherit;
  }

  .icon-assessment {
    font-size:51px;
  }
  .assessment-creator {
    color: #a9a9a9;
  }
  .CLO {
    font-size: 27px;
  }

  .CLO {
     color: #0a558f;
  }
  .icon_autotag {
    font-size:28px;
  }
  .assesment-title {
    margin-top:3px;
  }
  .right-panel {
    height: calc(100vh - 286px);
    overflow-y: auto;
    margin-left: 150px;
  }
  select.form-control:not([size]):not([multiple]) {
    height:auto;
  }
  textarea {
    padding: 7px 11px;
    height: 86px;
  }
  input {
    padding-left: 11px;
  }

</style>



// WEBPACK FOOTER //
// src/app/assessment/components/CreateAssessment.vue